
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/trial",
      function () {
        return require("private-next-pages/demo/trial/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/trial"])
      });
    }
  